import React from 'react'
import Schema_How_Peppol_Works from '../../assets/images/wat-is-peppol.png'
import { useWindowSize } from "@uidotdev/usehooks";
import { useTranslation } from 'react-i18next';

const WhatIsPeppolPage = () => {
    const { width } = useWindowSize()

    const { t } = useTranslation()

    const headerStyle = (width && width > 768) ? { minHeight: "clamp(12.5rem, 60vw, 21rem)" } : { minHeight: "30rem" };
    
  return (
    <div className='min-h-dvh'>
        <div className='container flex flex-col gap-8 py-16'>
            <div style={headerStyle} className='relative bg-neutral-400'>
                <img
                    src="/images/group-invoicing.jpeg"
                    alt="Shapes"
                    className="absolute inset-0 object-cover w-full h-full brightness-50"
                />
            </div>

            <h1 className='text-4xl font-bold text-center md:text-5xl'>{t('what-is-peppol.Wat is Peppol')}</h1>

            <div className='flex flex-col gap-2'>
                <h2 className='text-lg font-bold'>{t('what-is-peppol.Europese wetgeving')}</h2>
                <p>{t('what-is-peppol.Peppol laat toe om op een gestructureerde manier elektronische documenten')}</p>
                <p>{t('what-is-peppol.Peppol is met andere woorden een kader dat door de Europese Commissie')}</p>
            </div>

            <div className='flex flex-col gap-2'>
                <h2 className='text-lg font-bold'>{t('what-is-peppol.BTW gap')}</h2>
                <p>{t('what-is-peppol.Met de invoering van de e-facturatie heeft de Belgische regering de intentie')}</p>
                <p>{t('what-is-peppol.Elektronische facturen bevatten door de automatisering van het proces')}</p>
            </div>

            <div className='flex flex-col gap-2'>
                <h2 className='text-lg font-bold'>{t('what-is-peppol.Hoe werkt Peppol')}</h2>
                <p>{t('what-is-peppol.Het Peppol-netwerk is in de eerste plaats een netwerk die een sterke nadruk')}</p>
                <p className='font-bold'>{t('what-is-peppol.Van 2-corner model naar 4-corner model')}</p>
                <p>{t('what-is-peppol.Elektronische facturatie vervangt het zogenaamde 2-corner model')}</p>
            </div>

            <img src={Schema_How_Peppol_Works} className='w-fit h-96'/>
        </div>
    </div>
  )
}

export default WhatIsPeppolPage